<!--
 * @Descripttion: 带table列表的抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 22:08:03
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-14 11:42:53
-->
<template>
	<div>
		<el-drawer
			:title="title"
			:visible.sync="visible"
			:append-to-body="appendToBody"
			:size="800"
			:before-close="handleClose"
			:wrapperClosable="wrapperClosable"
			custom-class="drawer-template"
		>
			<div class="content" v-loading="loading">
				<rules-oper :platformId="platformId" :rules="rules" @handleFormChange="handleFormChange" />
			</div>
			<div class="drawer-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button @click="confirm" type="primary" :loading="btnLoading">保 存</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import rulesOper from '../../components/rulesOper.vue';
import { institutionGetRule, institutionSaveRule } from '@/api/cooperativeShop';
export default {
	components: {
		rulesOper,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_DY.value,
		},
	},
	computed: {},
	data() {
		return {
			title: '协作规则', // 弹窗标题
			visible: false, // 弹窗显隐
			rules: {},
			btnLoading: false,
			loading: false,
		};
	},

	created() {
		this.initData();
	},
	mounted() {},
	methods: {
		// 主动显示弹窗
		show(id = 0) {
			this.shopId = id;
			this.visible = true;
			this.getRules();
		},
		async getRules() {
			this.loading = true;
			const { platformId, shopId } = this;
			try {
				const data = await institutionGetRule({ platformId, shopId });
				this.rules = data;
			} finally {
				this.loading = false;
			}
		},
		async confirm() {
			this.btnLoading = true;
			const { platformId, rules, shopId } = this;
			try {
				await institutionSaveRule({ platformId, shopId, ...rules });
				this.$message.success('编辑成功！');
				this.handleClose();
				this.$emit('refresh');
			} finally {
				this.btnLoading = false;
			}
		},
		// 清空数据并关闭弹窗
		handleClose() {
			// 关闭弹窗
			this.rules = {};
			this.btnLoading = false;
			this.loading = false;
			this.visible = false;
		},
		handleFormChange(val) {
			this.rules = val;
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.content {
	.searchBtn {
		width: 70px;
		background-color: @color-primary;
		color: #ffffff;
		font-size: 13px;
		border-top-left-radius: 2px;
		border-bottom-left-radius: 2px;
		position: absolute;
		right: 0;
		top: 0px;
		border: 1px solid @color-primary;
	}
	::v-deep .el-radio {
		margin-right: 10px;
	}
}
.drawer-footer {
	background-color: @color-white;
	z-index: 999;
}
</style>
